import { defineStore } from 'pinia'
import dashboardAPI from '@/api/reports/dashboard.api'

export const useDashboardStore = defineStore('dashboard', {
  state: () => ({
    summary: [],
    selectedQueues: [],
    isLoading: false
  }),
  actions: {
    getDashboardData() {
      this.selectedQueues = []
      this.isLoading = true
      dashboardAPI.get({}, 'summary')
        .then(({ data }) => this.summary = data.data)
        .finally(() => this.isLoading = false)
        .catch((error) => console.error('Unexpected error occurred:', error))
    },
    updateDashboardStats(stats) {
      stats.queue = stats.queueNumber
      const index = this.summary.findIndex((item) => item.queue === stats.queueNumber)
      this.summary[index] = stats
    }
  },
  getters: {
    filteredSummary() {
      if (!this.summary.length) return []
      return this.summary.filter((queue) => this.selectedQueues.length ? this.selectedQueues.includes(queue.queue) : queue)
    },
    summaryTotals() {
      return (
        this.filteredSummary
          // Filter according to queue
          .reduce((acc, item) => {
            Object.entries(item).forEach(([key, value]) => {
              if (key === 'queue' || key === 'type') return
              // Convert string numbers to actual numbers, handle NaN
              const numValue = typeof value === 'string' ? parseFloat(value) : value
              // Only add if it's a valid number
              if (!isNaN(numValue) && numValue !== null) {
                acc[key] = (acc[key] || 0) + numValue
              }
            })
            return acc
          }, {})
      )
    },
    outboundCalls() {
      if (!this.filteredSummary.length) return 0
      return this.filteredSummary.reduce((total, item) => {
        // Only count outbound calls and sum their total
        return item.type === 'outbound' ? total + (item.total || 0) : total
      }, 0)
    },
    inboundCalls() {
      if (!this.filteredSummary.length) return 0
      return this.filteredSummary.reduce((total, item) => {
        // Only count outbound calls and sum their total
        return item.type === 'inbound' ? total + (item.total || 0) : total
      }, 0)
    },
  }
})
